(function ($) {
  productContentCarouselV2 = {
    formatter: function (context) {
      return $('.product-content-carousel-v2', context);
    },
    runOnceContexts: {
      contexts: [document],
      processedContexts: {
      },
      check: function (context) {
        if (context.jquery) {
          if (context.length > 1) {
            throw new Error('Attempted to do a context check against more than one context.');

            return;
          }
          context = context[0];
        }

        for (var i = 0; i < this.contexts.length; i += 1) {
          if (context === this.contexts[i]) {
            if (this.processedContexts[i]) {
              return false;
            } else {
              this.processedContexts[i] = true;

              return true;
            }
          }
        }

        return true;
      }
    }
  };

  Drupal.behaviors.productContentCarouselV2 = {
    get: function (key) {
      if (typeof productContentCarouselV2[key] === 'function') {
        return productContentCarouselV2[key].apply(this, Array.prototype.slice.call(arguments, 1));
      } else {
        return productContentCarouselV2[key];
      }
    },

    set: function (key, val) {
      productContentCarouselV2[key] = val;
    },

    attach: function (context, settings) {
      if ($.isFunction($.fn.flexslider)) {
        var runOnceContexts = this.get('runOnceContexts');
        // if either we've not run this attach function 
        // against the document context or the context isn't document

        if (runOnceContexts.check(context)) {
          var self = this;
          var formatter = self.get('formatter', context);
          var flexViewPortWidth = 960;
          var correctionValue = 1;

          formatter.each(function () {
            var thisFormatter = $(this);

            thisFormatter.closest('.module').siblings('.module').addClass('remove-border');

            // default 3-column
            var itemMargin = 0;
            var visibleCols = 3;
            var itemWidth = (flexViewPortWidth / visibleCols) + correctionValue;

            // 5-column
            if (thisFormatter.hasClass('columns-5')) {
              itemMargin = 0;
              visibleCols = 5;
              itemWidth = flexViewPortWidth / visibleCols;
            }

            if (thisFormatter.hasClass('columns-4')) {
              itemMargin = 0;
              visibleCols = 4;
              itemWidth = (flexViewPortWidth / visibleCols) + correctionValue;
            }
            // 1-column
            if (thisFormatter.hasClass('columns-1')) {
              itemMargin = 0;
              itemWidth = 950;
              visibleCols = 1;

              // 1-column mobile
              if ($('body').hasClass('device-mobile')) {
                itemWidth = 288;
              }
            }

            // 2-column - for now mobile only
            if ($('body').hasClass('device-mobile')) {
              // 2-column mobile
              if (thisFormatter.hasClass('columns-2')) {
                itemMargin = 0;
                itemWidth = 150;
                visibleCols = 2;
              }
            }

            // setup rows
            var items = thisFormatter.find('.slides > li');

            items.each(function (i) {
              $(this).prepend('<div class="number">' + (i + 1) + '</div>');
            });

            // build flexslider
            var flexsliderID = thisFormatter.children('.flexslider').attr('id');
            var flexslider = $('#' + flexsliderID);
            var slideshow = false;

            if (flexslider.hasClass('flexslider-slideshow')) {
              slideshow = true;
            }

            var onSliderStart = function (sliderObj) {
              var $slidesInner = sliderObj.find('li .inner'),
                ch = 0,
                resizeTimer = null,
                resizeDelay = 400;

              $('img').on('load', function() {
                matchHeight();
              });
              $(window).resize(function () {
                matchHeight();
              });
              function matchHeight() {
                if (resizeTimer) {
                  clearTimeout(resizeTimer);
                }
                resizeTimer = setTimeout(function () {
                  $slidesInner.each(function () {
                    var $el = $(this);

                    $el.css({ height: 'auto' });
                    var h = $el.outerHeight(true);

                    if (h > ch) {
                      ch = h;

                      return;
                    }
                  }).height(ch);
                }, resizeDelay);
              }
            };

            flexslider.flexslider({
              animation: 'slide',
              animationLoop: true,
              itemMargin: itemMargin,
              itemWidth: itemWidth,
              minItems: visibleCols,
              maxItems: visibleCols,
              move: 1,
              // slideshow: slideshow
              slideshow: false,
              start: function (flexslider) {
                onSliderStart(flexslider);
              }
            });
            var lastTimeoutId;

            $(window).on('resize', function () {
              clearTimeout(lastTimeoutId);
              lastTimeoutId = setTimeout(function () {
                flexslider.flexslider('resize');
              }, 400);
            });
          });
        }
      }
    }
  };
})(jQuery);
